import * as _ from "lodash";
export var getLinkByName = function (from, name) {
    if (name === void 0) { name = "self"; }
    if (!from)
        return undefined;
    return _.find(from.links, function (f) { return f.ref === name; });
};
export var getUriFromLinkByName = function (from, name) {
    if (name === void 0) { name = "self"; }
    var _a;
    if (!from)
        return undefined;
    return (_a = (_.find(from.links, function (f) { return f.ref === name; }))) === null || _a === void 0 ? void 0 : _a.uri;
};
//# sourceMappingURL=LinkHelper.js.map